import { createElement } from 'react';
import { Input } from '@bedrock/components';
const LcInput = function LcInput(props) {
    return createElement(Input, { ...props });
};
export default LcInput;
